import { render, staticRenderFns } from "./b2b-bell-menu.vue?vue&type=template&id=4af83c4e&scoped=true"
import script from "./b2b-bell-menu.vue?vue&type=script&lang=js"
export * from "./b2b-bell-menu.vue?vue&type=script&lang=js"
import style0 from "./b2b-bell-menu.vue?vue&type=style&index=0&id=4af83c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af83c4e",
  null
  
)

export default component.exports